module.exports = __webpack_public_path__ + "static/img/a041.03155d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a041.jpg
// module id = ZVJs
// module chunks = 0